<template>
  <div>
    <v-list two-line subheader>
      <v-subheader inset>Credenciados ({{partners.length}})</v-subheader>
      <v-list-tile
        v-for="item in partners"
        :key="item.id"
        avatar
        @click.stop="openEditPartnerDialog(item)"
      >
        <v-list-tile-avatar>
          <v-icon color="accent">domain</v-icon>
        </v-list-tile-avatar>
        <v-list-tile-content>
          <v-list-tile-title>{{ item.name }}</v-list-tile-title>
          <v-list-tile-sub-title>
            {{ item.contactName }}
            <span class="grey--text text--lighten-2">|</span>
            {{ item.phone }}
            <span class="grey--text text--lighten-2">|</span>
            {{ item.email }}
            <span class="grey--text text--lighten-2">|</span>
            {{ item.address }}
          </v-list-tile-sub-title>
        </v-list-tile-content>
      </v-list-tile>
    </v-list>

    <v-tooltip left>
      <template v-slot:activator="{ on }">
        <v-btn fab bottom right color="#db1a83" dark fixed @click="openNewPartnerDialog" v-on="on">
          <v-icon>add</v-icon>
        </v-btn>
      </template>
      <span>Novo Credenciado</span>
    </v-tooltip>

    <v-dialog v-model="dialog" width="800px" persistent>
      <v-card>
        <v-form ref="form" @submit.prevent="savePartner" lazy-validation>
          <v-card-title class="grey lighten-4 py-4 title">Dados cadastrais do credenciado</v-card-title>
          <v-container grid-list-sm class="pa-4">
            <v-layout row wrap>
              <v-flex xs12>
                <v-text-field
                  prepend-icon="business"
                  placeholder="Nome"
                  v-model="selectedPartner.name"
                  :rules="[rules.required]"
                  autofocus
                  v-if="dialog"
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  prepend-icon="email"
                  placeholder="Email"
                  v-model="selectedPartner.email"
                  :rules="[rules.required, rules.email]"
                  :disabled="selectedPartner.id"
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  prepend-icon="phone"
                  placeholder="Número de telefone"
                  v-model="selectedPartner.phone"
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  prepend-icon="location_on"
                  placeholder="Endereço"
                  v-model="selectedPartner.address"
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  prepend-icon="person"
                  placeholder="Contato"
                  v-model="selectedPartner.contactName"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-container>
          <v-card-actions>
            <v-btn
              flat
              color="red"
              @click="deletePartner"
              v-if="selectedPartner.id"
              :loading="deleting"
            >Remover</v-btn>
            <v-btn
              flat
              color="blue-grey lighten-1"
              @click="sendSignInEmail"
              v-if="selectedPartner.id"
              :loading="sendingSignInEmail"
            >Enviar email de login</v-btn>
            <v-spacer></v-spacer>
            <v-btn flat color="primary" @click="dialog = false">Cancelar</v-btn>
            <v-btn color="primary" type="submit" :loading="saving">Salvar</v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import db from "@/services/database";
import firebase from 'firebase/app';
import 'firebase/auth';

export default {
  data: () => {
    return {
      dialog: false,
      selectedPartner: newEmptyPartner(),
      partners: [],
      rules: {
        required: v => !!v || "requerido",
        email: v =>
          /^\w+([+.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,4})+$/.test(v) ||
          "email inválido"
      },
      saving: false,
      deleting: false,
      sendingSignInEmail: false
    };
  },
  created() {
    db.collection("partners")
      .orderBy("name")
      .onSnapshot(snapshot => {
        let items = [];
        snapshot.forEach(doc => {
          items.push(buildPartner(doc));
        });
        this.partners = items;
      });
  },
  methods: {
    openNewPartnerDialog: function() {
      this.selectedPartner = newEmptyPartner();
      this.$refs.form.resetValidation();
      this.dialog = true;
    },
    openEditPartnerDialog: function(item) {
      this.selectedPartner = { ...item };
      this.$refs.form.resetValidation();
      this.dialog = true;
    },
    deletePartner: async function() {
      if (!confirm("¿Você tem certeza?")) {
        return;
      }
      try {
        this.deleting = true;

        await db
          .collection("partners")
          .doc(this.selectedPartner.id)
          .delete();
        this.dialog = false;
      } catch (error) {
        alert(error);
      } finally {
        this.deleting = false;
      }
    },
    sendSignInEmail: async function() {
      try {
        this.sendingSignInEmail = true;
        await firebase
          .auth()
          .sendSignInLinkToEmail(this.selectedPartner.email, {
            url: "https://app.cartaomedplus.com/linklogin",
            handleCodeInApp: true
          });
        alert("O email foi enviado.");
        this.dialog = false;
      } catch (err) {
        alert(err);
      } finally {
        this.sendingSignInEmail = false;
      }
    },
    savePartner: async function() {
      if (!this.$refs.form.validate()) {
        return;
      }

      try {
        this.saving = true;

        if (this.selectedPartner.id) {
          //update partner
          await db
            .collection("partners")
            .doc(this.selectedPartner.id)
            .update({
              name: this.selectedPartner.name,
              phone: this.selectedPartner.phone || "",
              address: this.selectedPartner.address || "",
              contactName: this.selectedPartner.contactName || ""
            });
        } else {
          //save new partner

          //valid email unique
          let docs = await db
            .collection("partners")
            .where("email", "==", this.selectedPartner.email.toLowerCase())
            .get();
          if (docs.size > 0) {
            throw "email duplicado";
          }

          //create new user
          await db.collection("users").add({
            email: this.selectedPartner.email,
            role: "partner"
          });

          //create new partner
          await db.collection("partners").add({
            name: this.selectedPartner.name,
            email: this.selectedPartner.email.toLowerCase(),
            phone: this.selectedPartner.phone || "",
            address: this.selectedPartner.address || "",
            contactName: this.selectedPartner.contactName || "",
            approved: true
          });
        }
        this.dialog = false;
      } catch (err) {
        alert(err);
      } finally {
        this.saving = false;
      }
    }
  }
};

function buildPartner(doc) {
  return {
    id: doc.id,
    name: doc.data().name,
    email: doc.data().email,
    phone: doc.data().phone,
    address: doc.data().address,
    contactName: doc.data().contactName,
    approved: doc.data().approved
  };
}

function newEmptyPartner() {
  return {
    name: "",
    email: "",
    phone: "",
    address: "",
    contactName: "",
    approved: true
  };
}
</script>
